// This file is auto-generated by scripts/generate-version.js
// Do not edit manually - it will be overwritten on build

export const version = {
  gitCommit: 'a67197654',
  buildTime: '2026-11-05T13:29:42.843Z',
} as const;
